import { RefObject } from 'react'

export const openFileDialog = (inputRef?: RefObject<HTMLInputElement>) => {
  if (inputRef?.current) {
    // Mirror FileButton behavior: reset value so selecting the same file name as a previous upload still triggers change.
    inputRef.current.value = ''
    inputRef.current.click()
  }
}
